import { Tooltip as MuiTooltip, TooltipProps as MuiTooltipProps, tooltipClasses } from '@mui/material';

interface TooltipProps extends MuiTooltipProps {
  tooltipStyle?: React.CSSProperties;
}

function Tooltip(props: TooltipProps) {
  const { tooltipStyle, ...rest } = props;
  return (
    <MuiTooltip
      componentsProps={{
        popper: {
          sx: {
            [`&.${tooltipClasses.popper}[data-popper-placement*="bottom"] .${tooltipClasses.tooltip}`]:
              {
                marginTop: 0,
              },
            [`&.${tooltipClasses.popper}[data-popper-placement*="top"] .${tooltipClasses.tooltip}`]:
              {
                marginBottom: 0,
              },
          },
        },
        tooltip: {
          sx: {
            background: '#303030',
            color: '#f2f2f2',
            whiteSpace: 'pre-line',
            ...tooltipStyle,
          },
        },
      }}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...rest}
    />
  );
}

export default Tooltip;
